// extracted by mini-css-extract-plugin
export default {"headerWithButtons":"HeaderWithButtons_headerWithButtons__ZC+Ed","headerWithButtons__buttons":"HeaderWithButtons_headerWithButtons__buttons__7R10U"};